import styled from 'styled-components';

const Li = styled.li`
  list-style-type: disc;
  margin-inline-start: 40px;
`;

const ListItem = ({ children }) => {
  if (!Array.isArray(children)) {
    return null;
  }
  const [text, ...otherChildrens] = children;

  if (children.length === 1) {
    return <Li>{text}</Li>;
  }
  if (typeof otherChildrens[0] === 'string') {
    return <Li>{children}</Li>;
  }
  return (
    <Li>
      <span>{text}</span>
      {otherChildrens}
    </Li>
  );
};

export default ListItem;
